const personalRecommendations1Data = {
    "productName": "productName 1",
    "imageUrl": "https://m.media-amazon.com/images/I/91-Mn7f3Z8L._AC_UY218_.jpg",
    "affiliateUrl": "https://amzn.to/4aFLNkT",
    "productUrl": "https://www.amazon.in/Custom-Childrens-Storybook-Personalized-Birthday/dp/B0D8WL3PLP/ref=sr_1_3?crid=2VAMMXL07O9CA&dib=eyJ2IjoiMSJ9.kTWVpPWJcDZjIo0ALgIqJxSMuCxgLkta_hK5PuSKMt7nQkMQEgmDJmcQKQh8gfYHmqm58YcsWUWLM1_HfrS_h0989g8dTE3KqPWRcv0qOn_-5vOHakezfUdDbOM-RuSXAGYolb6h1l1vJVSFAk522ixhGqGIWHKkomRroC3KBy466QX-3zx6k6dEo0h2230mw4FkFdp02fm5P-y2lfq-yOs09WXUJ2ARHuce66uyptE.6VKSs_iHiguUREi2Zvuhbv-N6ry2aRoAc7qJspW4JmM&dib_tag=se&keywords=Personalized+Children%27s+Storybook&qid=1738560769&s=books&sprefix=personalized+children%27s+storybook%2Cstripbooks%2C192&sr=1-3",
    "price": "",
    "ratingValue": ""
}
export const personalRecommendationsBlog = {
    personalRecommendations1: {
        "hideFromBlogList": true,
        "title": "Personal recommendations",
        "subTitle": "",
        "image": "/assets/img/thumbnails/book-2.png",
        "url": "/personal-recommendations",
        "date": "",
        "tags": [""],
        "categories": [""],
        "pageStructure": [
            {
                "component": "paragraphBoldItalic",
                "text": ""
            },
            {
                "component": "productList",
                "list": [
                    {
                        "name": "NIVIA Football Studs",
                        "price": "703 Rs",
                        "targetUrl": "https://amzn.to/40RVQi1",
                        "imgSrc": "https://m.media-amazon.com/images/I/81tLQzejuzL._SX679_.jpg",
                        "ratingValue": '',
                        "disclaimer": true,
                        "description": {
							"type": "list",
                            "list": [
                                {
                                    "title": "Brand",
                                    "text": "NIVIA"
                                },
                                {
                                    "title": "Model Name",
                                    "text": "Mirrorless"
                                },
								{
									"title" : "Link",
									"text": `<<Click here to buy | https://amzn.to/40RVQi1 >>`
								}
							]
                        }
                    },
					{
                        "name": "Jayci Mart 7 XL Multipurpose Drawer Plastic Modular Chest Storage Organizer Home",
                        "price": "1219 Rs",
                        "targetUrl": "https://amzn.to/4hx7XIK",
                        "imgSrc": "https://m.media-amazon.com/images/I/61UHWfxuvqL._SX679_.jpg",
                        "ratingValue": '',
                        "disclaimer": true,
                        "description": {
							"type": "list",
                            "list": [
                                {
                                    "title": "Brand",
                                    "text": "Jayci Mart"
                                },
                                {
                                    "title": "Material",
                                    "text": "Plastic"
                                },
								{
									"title" : "Link",
									"text": `<<Click here to buy | https://amzn.to/4hx7XIK >>`
								}
							]
                        }
                    },
					{
                        "name": "Rellon Industries Study Table",
                        "price": "599 Rs",
                        "targetUrl": "https://amzn.to/4aTqjB4",
                        "imgSrc": "https://m.media-amazon.com/images/I/61okssN3Y6L._SX679_.jpg",
                        "ratingValue": '',
                        "disclaimer": true,
                        "description": {
							"type": "list",
                            "list": [
                                {
                                    "title": "Brand",
                                    "text": "Rellon"
                                },
                                {
                                    "title": "Material",
                                    "text": "Plastic"
                                },
								{
									"title" : "Link",
									"text": `<<Click here to buy | https://amzn.to/4aTqjB4 >>`
								}
							]
                        }
                    },
					{
                        "name": "Bacca Bucci Alpine High Ankle 6 inches Riding Boots",
                        "price": "1499 Rs",
                        "targetUrl": "https://amzn.to/3ErsaRB",
                        "imgSrc": "https://m.media-amazon.com/images/I/71pnTDhyNpL._SY695_.jpg",
                        "ratingValue": '',
                        "disclaimer": true,
                        "description": {
							"type": "list",
                            "list": [
                                {
                                    "title": "Brand",
                                    "text": "Bacca Bucci"
                                },
                                {
                                    "title": "Material",
                                    "text": "Faux Leather, Rubber"
                                },
								{
									"title" : "Link",
									"text": `<<Click here to buy | https://amzn.to/3ErsaRB >>`
								}
							]
                        }
                    }
                ]
            }
        ],
        "socialMediaLinks": {
            "facebook": "//facebook.com"
        }
    }
};
export const tempData = {
    blogs: [
        personalRecommendationsBlog.personalRecommendations1
    ]
};
